import Vue from "vue";
import VueResource from "vue-resource";
import { API_PUBLIC_ROOT, ROOT } from "@/config";

Vue.use(VueResource);

Vue.http.options.crossOrigin = true;
Vue.http.options.credentials = false;
Vue.http.interceptors.push((request, next) => {
  request.headers = request.headers || {};
  if (
    localStorage.getItem("authToken") &&
    localStorage.getItem("authToken").length > 0
  ) {
    request.headers.set(
      "Authorization",
      "Bearer " + localStorage.getItem("authToken")
    );
  }
  next();
});

export const ThemeResource = Vue.resource(
  API_PUBLIC_ROOT + "v1/oneapp/theme{/themeId}"
);
export const OneappWebcheckinEnabledResource = Vue.resource(
  API_PUBLIC_ROOT + "v1/oneapp/webcheckin{/propertyId}/enabled"
);

export const MailResource = Vue.resource(
  "https://demo06.onesquare.tv/email/send",
  {},
  {},
  {
    emulateJSON: false,
  }
);

export const SettingsResource = Vue.resource(
  API_PUBLIC_ROOT + "v1/property{/propertyId}/oneapp/settings"
);

export const ONEKeyResource = Vue.resource(
  API_PUBLIC_ROOT + "v2/property{/propertyId}/onekey/session",
  {},
  {},
  {
    emulateJSON: false,
  }
);

export const TACCoursesResource = Vue.resource(
  ROOT + "/api/tac/v1/courses",
  {},
  {},
  {
    emulateJSON: false,
  }
);

export const TACAccountVerifyResource = Vue.resource(
  ROOT + "/api/tac/v1/account-verify",
  {},
  {},
  {
    emulateJSON: false,
  }
);

export const TACBookCourseResource = Vue.resource(
  ROOT + "/api/tac/v1/add-booking-class",
  {},
  {},
  {
    emulateJSON: false,
  }
);

export const TermsIndexResource = Vue.resource(
  API_PUBLIC_ROOT + "v1/property{/propertyId}/oneapp/terms/index"
);
